var $ = jQuery.noConflict()

var CRAFTYCLICKS = {};

CRAFTYCLICKS.url = 'https://pcls1.CRAFTYCLICKS.co.uk/json/rapidaddress';
CRAFTYCLICKS.response = 'data_formatted';
CRAFTYCLICKS.sort = 'asc';
CRAFTYCLICKS.key = '7e1b6-56b1e-300e8-05a93';
CRAFTYCLICKS.hint = '<option>Look up your address by entering your postcode and clicking \'Find Address\'</option>';

// $.fn.craftyclicks = function() {
//   var trigger = $(this);

//   $(trigger).each(function() {
//     CRAFTYCLICKS.init(this);
//   });
// };

var self = module.exports = {
  init: function(trigger) {
    $(trigger).on('change', function() {
      CRAFTYCLICKS.trigger(this);
    });
  }
}

CRAFTYCLICKS.trigger = function(trigger) {
  var input = $(trigger);
  var output = $(trigger).data('target');
  var postcode = $(input).val();


  CRAFTYCLICKS.getData(output, postcode);
};

CRAFTYCLICKS.processData = function(output, data) {
  var options = CRAFTYCLICKS.sortData(data);
  CRAFTYCLICKS.update(output, options);
};

CRAFTYCLICKS.reset = function(output, error) {
  $(output).prop('disabled', true);
  // console.log(error);

  if (error) {
    var html = '<option>' + error + '</option>';
    $(output).html(html);
  } else {
    $(output).html(CRAFTYCLICKS.hint);
  }
};

CRAFTYCLICKS.update = function(output, options) {
  $(output).html('');
  $(output).prop('disabled', false);

  for (var i = 0; i < options.length; i++) {
    $(output).append('<option value="' + options[i] + '">' + options[i] + '</option>');
  }

  $(output).closest('.form-group').removeClass('display-none')
};

// Get the address data
CRAFTYCLICKS.getData = function(output, postcode) {
  $.ajax({
    url: CRAFTYCLICKS.url,
    dataType: 'jsonp',
    data: {
      postcode: postcode,
      response: CRAFTYCLICKS.response,
      sort: CRAFTYCLICKS.sort,
      key: CRAFTYCLICKS.key
    },
    success: function(data) {
      if (data.error_code != undefined){
        CRAFTYCLICKS.reset(output, data.error_msg);
      } else {
        CRAFTYCLICKS.processData(output, data);
      }
    }
  });
};

// Sort data into array of address strings
CRAFTYCLICKS.sortData = function(data) {
  var town = data.town;
  var postcode = data.postcode;
  var points = data.delivery_points;
  var addresses = [];

  for (var i = 0; i < points.length; i++) {
    var address = '';
    address += (points[i].organisation_name !== '') ? points[i].organisation_name + ', ' : '';
    address += (points[i].department_name !== '') ? points[i].department_name + ', ' : '';
    address += (points[i].line_1 !== '') ? points[i].line_1 + ', ' : '';
    address += (points[i].line_2 !== '') ? points[i].line_2 + ', ' : '';
    address += (town !== '') ? town + ', ' : '';
    address = address.replace(/,\s*$/, "");
    addresses.push(address);
  }
  return addresses;
};
